import { render, staticRenderFns } from "./ShopPage.vue?vue&type=template&id=bcbab05a&scoped=true"
import script from "./ShopPage.vue?vue&type=script&lang=js"
export * from "./ShopPage.vue?vue&type=script&lang=js"
import style0 from "./ShopPage.vue?vue&type=style&index=0&id=bcbab05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbab05a",
  null
  
)

export default component.exports